import { DayPicker, DayPickerProps } from 'react-day-picker';
import { cn } from '../../utils';

export type CalendarProps = DayPickerProps;
export const Calendar = ({
  className,
  classNames,
  showOutsideDays = true,
  fixedWeeks = true,
  ...props
}: CalendarProps) => {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      fixedWeeks={fixedWeeks}
      className={cn('lf:p-3', className)}
      classNames={{
        months: 'lf:flex lf:flex-row',
        month: 'lf:space-y-4',
        selected:
          '[&>button]:l-btn-primary', // Highlight the selected day
        disabled: 'lf:text-neutral-500 lf:cursor-not-allowed',
        caption_label: 'lf:text-title-md lf:capitalize',
        nav: 'lf:space-x-1 lf:flex lf:items-center lf:absolute lf:right-4',
        button_next: 'lf:l-btn lf:l-icon-btn lf:l-btn-sm lf:l-btn-tertiary',
        button_previous: 'lf:l-btn lf:l-icon-btn lf:l-btn-sm lf:l-btn-tertiary',

        nav_button: 'lf:l-btn lf:l-btn-sm lf:l-btn-tertiary',
        week: 'lf:flex lf:gap-2',
        weeks: 'lf:flex lf:flex-col lf:gap-2',
        weekdays: 'lf:flex lf:flex-row lf:justify-between lf:gap-2',
        weekday: 'lf:text-label-lg lf:h-8 lf:w-8 lf:text-center',
        day_button:
          'lf:text-center lf:l-btn lf:l-icon-btn lf:l-btn-sm lf:l-btn-tertiary lf:table-cell lf:h-8 lf:w-8 lf:p-0',
        day_hidden: 'lf:invisible',
        ...classNames,
      }}
      {...props}
    />
  );
};
